module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mint-file-list"
  }, [(_vm.label !== '') ? _c('h4', {
    staticClass: "mint-file-list-title mt-color-grey-lv3"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('mt-cell-group', _vm._l((_vm.fileList), function(item) {
    return _c('mt-cell', {
      key: item.id,
      attrs: {
        "title": item.name,
        "is-link": ""
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-685ceda5","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/file-list/src/file-list.vue
// module id = 166
// module chunks = 0